<div class="payment-integration-outer">
  <div class="form-outer">
    <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="col">

        <div class="full-width">
          <div class="form__group">
            <label class="form__label">Service <span class="required">*</span></label>
            <p-select 
              class="form__dropdown select-box" 
              name="service" 
              [options]="services" 
              placeholder="Select"
              optionLabel="name"
              optionValue="id"
              formControlName="service"
              [class.ng-invalid]="isFieldInvalid('service')">
            </p-select>
            <small class="error-message" *ngIf="isFieldInvalid('service')">
              {{ getFieldError('service') }}
            </small>
          </div>
        </div>
        
        <div class="form__group">
          <label class="form__label">Account Token <span class="required">*</span></label>
          <input 
            type="text" 
            class="form__control" 
            pInputText
            formControlName="accountToken"
            [class.ng-invalid]="isFieldInvalid('accountToken')">
          <small class="error-message" *ngIf="isFieldInvalid('accountToken')">
            {{ getFieldError('accountToken') }}
          </small>
        </div>

        <div class="form__group">
          <label class="form__label">Account ID <span class="required">*</span></label>
          <input 
            type="text" 
            class="form__control" 
            pInputText
            formControlName="accountId"
            [class.ng-invalid]="isFieldInvalid('accountId')">
          <small class="error-message" *ngIf="isFieldInvalid('accountId')">
            {{ getFieldError('accountId') }}
          </small>
        </div>

        <div class="form__group">
          <label class="form__label">Acceptor ID <span class="required">*</span></label>
          <input 
            type="text" 
            class="form__control" 
            pInputText
            formControlName="acceptorId"
            [class.ng-invalid]="isFieldInvalid('acceptorId')">
          <small class="error-message" *ngIf="isFieldInvalid('acceptorId')">
            {{ getFieldError('acceptorId') }}
          </small>
        </div>

         <div class="form__group">
          <label class="form__label">Terminal ID <span class="required">*</span></label>
          <input 
            type="text" 
            class="form__control" 
            pInputText
            formControlName="terminalId"
            [class.ng-invalid]="isFieldInvalid('terminalId')">
          <small class="error-message" *ngIf="isFieldInvalid('terminalId')">
            {{ getFieldError('terminalId') }}
          </small>
        </div>

        <div class="form__group">
          <label class="form__label">Transaction URL <span class="required">*</span></label>
          <input 
            type="text" 
            class="form__control" 
            pInputText
            formControlName="transactionUrl"
            [class.ng-invalid]="isFieldInvalid('transactionUrl')">
          <small class="error-message" *ngIf="isFieldInvalid('transactionUrl')">
            {{ getFieldError('transactionUrl') }}
          </small>
        </div>

        <div class="form__group">
          <label class="form__label">Reporting URL <span class="required">*</span></label>
          <input 
            type="text" 
            class="form__control" 
            pInputText
            formControlName="reportingUrl"
            [class.ng-invalid]="isFieldInvalid('reportingUrl')">
          <small class="error-message" *ngIf="isFieldInvalid('reportingUrl')">
            {{ getFieldError('reportingUrl') }}
          </small>
        </div>

        <div class="form__group">
          <label class="form__label">Services URL <span class="required">*</span></label>
          <input 
            type="text" 
            class="form__control" 
            pInputText
            formControlName="servicesUrl"
            [class.ng-invalid]="isFieldInvalid('servicesUrl')">
          <small class="error-message" *ngIf="isFieldInvalid('servicesUrl')">
            {{ getFieldError('servicesUrl') }}
          </small>
        </div>

        <div class="form__group">
          <label class="form__label">Hosted Payment URL <span class="required">*</span></label>
          <input 
            type="text" 
            class="form__control" 
            pInputText
            formControlName="hostedPaymentUrl"
            [class.ng-invalid]="isFieldInvalid('hostedPaymentUrl')">
          <small class="error-message" *ngIf="isFieldInvalid('hostedPaymentUrl')">
            {{ getFieldError('hostedPaymentUrl') }}
          </small>
        </div>

        <div class="form__group">
          <label class="form__label">Return URL <span class="required">*</span></label>
          <input 
            type="text" 
            class="form__control" 
            pInputText
            formControlName="returnUrl"
            [class.ng-invalid]="isFieldInvalid('returnUrl')">
          <small class="error-message" *ngIf="isFieldInvalid('returnUrl')">
            {{ getFieldError('returnUrl') }}
          </small>
        </div>

      </div>

      <div class="btns">
        <button 
          class="btn btn--primary" 
          type="submit" 
          [disabled]="loading ">
          {{ loading ? 'Saving...' : 'Validate & Save' }}
        </button>
        <button 
          class="btn btn--secondary" 
          type="button"
          routerLink="/admin/settings"
          [disabled]="loading">
          Cancel
        </button>
      </div>
    </form>
  </div>

</div>

<div class="loader-block" *ngIf="loading">
  <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff" animationDuration=".8s">
  </p-progressSpinner>
</div>
